import { create } from 'zustand'
import { DateTime } from 'luxon'
import {
    IDayHistoryResponse,
    InterpolatedPosition,
    PlaybackSpeed,
} from '../interfaces/dayHistory.ts'

interface DayHistoryState {
    /** Whether day history mode is active */
    active: boolean
    setActive: (active: boolean) => void

    /** The API response data for the current day */
    pathData: IDayHistoryResponse | null
    setPathData: (data: IDayHistoryResponse | null) => void

    /** Whether the animation is currently playing */
    isPlaying: boolean
    setIsPlaying: (playing: boolean) => void

    /** Playback speed multiplier */
    playbackSpeed: PlaybackSpeed
    setPlaybackSpeed: (speed: PlaybackSpeed) => void

    /** Current simulated time (epoch seconds) */
    currentTime: number
    setCurrentTime: (time: number) => void

    /** Current interpolated position of the marker */
    currentPosition: InterpolatedPosition | null
    setCurrentPosition: (pos: InterpolatedPosition | null) => void

    /** The currently selected date for day history (user's timezone) */
    selectedDate: DateTime | null
    setSelectedDate: (date: DateTime | null) => void

    /** Whether data is loading */
    loading: boolean
    setLoading: (loading: boolean) => void

    /** Error message if data fetch failed */
    error: string
    setError: (error: string) => void

    /** Reset all state (when exiting day history mode) */
    reset: () => void
}

const initialState = {
    active: false,
    pathData: null,
    isPlaying: false,
    playbackSpeed: 360 as PlaybackSpeed,
    currentTime: 0,
    currentPosition: null,
    selectedDate: null as DateTime | null,
    loading: false,
    error: '',
}

const useDayHistoryStore = create<DayHistoryState>((set) => ({
    ...initialState,

    setActive: (active) => set({ active }),
    setPathData: (pathData) => set({ pathData }),
    setIsPlaying: (isPlaying) => set({ isPlaying }),
    setPlaybackSpeed: (playbackSpeed) => set({ playbackSpeed }),
    setCurrentTime: (currentTime) => set({ currentTime }),
    setCurrentPosition: (currentPosition) => set({ currentPosition }),
    setSelectedDate: (selectedDate) => set({ selectedDate }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),

    reset: () => set(initialState),
}))

export default useDayHistoryStore
